import React from 'react';
import Svg, {Path} from 'react-native-svg';
import {Props} from '../../../shared/assets/SvgProps';
import Typography from '@shared/constants/Typography';

const LargeCloseIcon: React.FC<Props> = ({
  width: _width = Typography.width.width24,
  height: _height = Typography.height.height24,
  color = '#707070',
}) => {
  return (
    <Svg width={_width} height={_height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M18 6L6 18"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6 6L18 18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default LargeCloseIcon;
